/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataAdminStockAdjustRecordListResVo } from './PageDataAdminStockAdjustRecordListResVo';
import {
    PageDataAdminStockAdjustRecordListResVoFromJSON,
    PageDataAdminStockAdjustRecordListResVoFromJSONTyped,
    PageDataAdminStockAdjustRecordListResVoToJSON,
    PageDataAdminStockAdjustRecordListResVoToJSONTyped,
} from './PageDataAdminStockAdjustRecordListResVo';

/**
 * 
 * @export
 * @interface ResponsePageDataAdminStockAdjustRecordListResVo
 */
export interface ResponsePageDataAdminStockAdjustRecordListResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataAdminStockAdjustRecordListResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataAdminStockAdjustRecordListResVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataAdminStockAdjustRecordListResVo}
     * @memberof ResponsePageDataAdminStockAdjustRecordListResVo
     */
    data?: PageDataAdminStockAdjustRecordListResVo;
}

/**
 * Check if a given object implements the ResponsePageDataAdminStockAdjustRecordListResVo interface.
 */
export function instanceOfResponsePageDataAdminStockAdjustRecordListResVo(value: object): value is ResponsePageDataAdminStockAdjustRecordListResVo {
    return true;
}

export function ResponsePageDataAdminStockAdjustRecordListResVoFromJSON(json: any): ResponsePageDataAdminStockAdjustRecordListResVo {
    return ResponsePageDataAdminStockAdjustRecordListResVoFromJSONTyped(json, false);
}

export function ResponsePageDataAdminStockAdjustRecordListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataAdminStockAdjustRecordListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataAdminStockAdjustRecordListResVoFromJSON(json['data']),
    };
}

export function ResponsePageDataAdminStockAdjustRecordListResVoToJSON(json: any): ResponsePageDataAdminStockAdjustRecordListResVo {
    return ResponsePageDataAdminStockAdjustRecordListResVoToJSONTyped(json, false);
}

export function ResponsePageDataAdminStockAdjustRecordListResVoToJSONTyped(value?: ResponsePageDataAdminStockAdjustRecordListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataAdminStockAdjustRecordListResVoToJSON(value['data']),
    };
}

